import type { MedicationRequest } from '@/services/med-req-detail'
import { colors } from '@/theme'
import { Box, Typography } from '@mui/material'
import { useState } from 'react'
import CollapsibleSection from './collapsible-section'
import SendFanEmailDialog from './send-fan-email-dialog'

interface RejectSectionProps {
  medRequest: MedicationRequest
  readOnly?: boolean
}

export default function RejectSection({ medRequest, readOnly }: RejectSectionProps) {
  const [showRejectionEmailDialog, setShowRejectionEmailDialog] = useState(false)
  const isRejected = medRequest.stage.toLowerCase().includes('rejected')

  return (
    <>
      <CollapsibleSection
        id='rejection'
        title='Rejection'
        actionButton={
          readOnly ? undefined : { label: 'Send rejection email', onClick: () => setShowRejectionEmailDialog(true) }
        }
      >
        {isRejected && medRequest.reasonForRejection ? (
          <Box
            sx={{
              p: 3,
              bgcolor: colors.background.surface,
              borderRadius: '12px'
            }}
          >
            <Typography sx={{ color: colors.text.secondary, fontSize: '14px', lineHeight: 1.6 }}>
              {medRequest.reasonForRejection}
            </Typography>
          </Box>
        ) : null}
      </CollapsibleSection>

      <SendFanEmailDialog
        open={showRejectionEmailDialog}
        medRequest={medRequest}
        onClose={() => setShowRejectionEmailDialog(false)}
        categoryFilter='rejection'
      />
    </>
  )
}
